import styles from './spinner.module.css'

export const Spinner = ({ wrapperStyles = '', spinnerStyles = '' }) => (
  <div className={`${styles.spinnerContainer} ${wrapperStyles}`}>
    <div className={`${styles.spinner} ${spinnerStyles}`} />
  </div>
)
